import { css } from 'linaria';

export const themeClass = css`
	--background: #ffffff;
	--primary-color: #6E37D8;
	--secondary-color: #DFCFF8;
	--button-primary-hover: #420AAD;
	--button-primary-text: #ffffff;
	--button-outline-text: #262626;
	--button-outline-border: #D9D9D9;
	--text-primary: #262626;
	--text-secondary: #595959;
	--text-tertiary: #8C8C8C;
	--whitelabel-hover: #262626;
	--whitelabel-hover-text: #262626;
	--barcode-light: #ffffff;
	--barcode-dark: #000000;
	--input-icon: #8C8C8C;
	--input-text: #262626;
	--input-border: #D9D9D9;
	--input-placeholder: #BFBFBF;
	--input-hover: #f5f5f5;
	--success-primary: #389E0D;
	--success-secondary: #CBF4C9;
	--error-primary: #FF4D4F;
	--error-secondary: #CF1322;

	//--background: #fff3e0;
	//--primary-color: #ff8f00;
	//--secondary-color: #DFCFF8;
	//--button-primary-hover: #ff8f00;
	//--button-primary-text: #ffc046;
	//--button-outline-text: #ab47bc;
	//--button-outline-border: #df78ef;
	//--text-primary: #d81b60;
	//--text-secondary: #880e4f;
	//--text-tertiary: #bc477b;
	//--whitelabel-hover: #80deea;
	//--barcode-light: #aee571;
	//--barcode-dark: red;
	//--input-icon: blue;
	//--input-text: #255d00;
	//--input-border: blue;
	//--input-placeholder: red;
	//--success-primary: #c6ff00;
	//--success-secondary: #eeff41;
	//--error-primary: #FF4D4F;
	//--error-secondary: #CF1322;

	z-index: 1000000000000;
	font-size: 16px;
	font-family: -apple-system, BlinkMacSystemFont, “Segoe UI”, Roboto, Helvetica, Arial, sans-serif, “Apple Color Emoji”, “Segoe UI Emoji”, “Segoe UI Symbol”;font-family: -apple-system,BlinkMacSystemFont, Helvetica, sans-serif;
	color: var(--text);
	position: relative;
	
	* {
	 	box-sizing: border-box;
	}
	
	svg {
	 	display: block;
	}
	
	a {
		color: var(--primary-color);
		text-decoration: none;
	}
	
	input,
	textarea,
	select {
	 	font: inherit;
	}
	
	button, input.form-control {
		font-family: -apple-system, BlinkMacSystemFont, “Segoe UI”, Roboto, Helvetica, Arial, sans-serif, “Apple Color Emoji”, “Segoe UI Emoji”, “Segoe UI Symbol”;font-family: -apple-system,BlinkMacSystemFont, Helvetica, sans-serif;
	}
	
	.hive-tooltip-overlay {
    	z-index: 100000;
	}
	.flag {
		display: block;
	}
`;
